import React, { useEffect } from "react";
import Chatops from "@thewebops/chatops-on-actioncable";
import { closeConversation, setOpenConversation } from "utils/chatViewing";
import { clearRequestedConversation, useRequestedConversation } from "utils/openConversation";

const { ConversationChannel, useChatopsOnActioncable } = Chatops;

// Rendered by the chat for each loaded conversation, inside its state, in place of the package's
// ConversationChannel (which it still renders). Reports the open conversation to the API, and opens the
// conversation a push notification asked for (nutivate-coaches#41).
const ConversationExtras = (props) => {
  const { conversation, selectedConversation } = props;
  const {
    state: { conversations },
    callbacks: { onConversationClick },
  } = useChatopsOnActioncable();
  const requested = useRequestedConversation();
  const isOpen = selectedConversation === conversation.id;

  useEffect(() => {
    if (!requested) return;
    const isMine = requested === String(conversation.id);
    // A conversation that isn't loaded is fetched by the first one, through the same click handler.
    const isMissing = !conversations.ids.some((id) => String(id) === requested);
    if (!isMine && !(isMissing && conversations.ids[0] === conversation.id)) return;

    clearRequestedConversation();
    onConversationClick(isMine ? conversation.id : Number(requested)).catch((error) =>
      console.warn(`The conversation ${requested} couldn't be opened`, error),
    );
  }, [requested, conversation.id, conversations.ids, onConversationClick]);

  useEffect(() => {
    if (!isOpen) return undefined;
    setOpenConversation(conversation.id);
    return () => closeConversation(conversation.id);
  }, [isOpen, conversation.id]);

  return <ConversationChannel {...props} />;
};

export default ConversationExtras;
